import * as types from "../actions/constants";

const INITIAL_STATE = {
    all_return_dispatches: {},
    return_dispatch_suppliers: {},
    return_dispatch_supplier_products: {},
    daily_summary: {},
    return_dispatch: {},
    candidates: { positions: [] },
    candidates_error: null,
    pending_suppliers: []
};

export default function(state = INITIAL_STATE, action) {
    switch(action.type) {
        case types.GET_RETURN_DISPATCHES_SUCCESS :
            return {...state, all_return_dispatches: action.payload.data};

        case types.GET_RETURN_DISPATCH_SUPPLIERS_SUCCESS :
            return {...state, return_dispatch_suppliers: action.payload.data};

        case types.GET_RETURN_DISPATCH_SUPPLIER_PRODUCTS_SUCCESS :
            return {...state, return_dispatch_supplier_products: action.payload.data};

        case types.GET_RETURN_DISPATCHES_DAILY_SUMMARY_SUCCESS :
            return {...state, daily_summary: action.payload.data};

        case types.GET_SPECIFIC_RETURN_DISPATCH_SUCCESS :
            return {...state, return_dispatch: action.payload.data};

        case types.GET_RETURN_DISPATCH_CANDIDATES_SUCCESS :
            return {...state, candidates: action.payload.data, candidates_error: null};

        case types.GET_RETURN_DISPATCH_CANDIDATES_FAIL :
            return {...state, candidates_error: action.error && action.error.response ? action.error.response.data : null};

        case types.GET_RETURN_DISPATCH_PENDING_SUPPLIERS_SUCCESS :
            return {...state, pending_suppliers: action.payload.data};

        default:
            return state;
    }
}
